import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const avatarColors = [
  'bg-pink-600 text-white dark:bg-pink-900/50 dark:text-pink-300',
  'bg-purple-600 text-white dark:bg-purple-900/50 dark:text-purple-300',
  'bg-blue-600 text-white dark:bg-blue-900/50 dark:text-blue-300',
  'bg-emerald-600 text-white dark:bg-emerald-900/50 dark:text-emerald-300',
  'bg-amber-600 text-white dark:bg-amber-900/50 dark:text-amber-300',
  'bg-red-600 text-white dark:bg-red-900/50 dark:text-red-300',
  'bg-indigo-600 text-white dark:bg-indigo-900/50 dark:text-indigo-300',
  'bg-cyan-600 text-white dark:bg-cyan-900/50 dark:text-cyan-300',
]




export function getAvatarColorClass(name: string | undefined | null) {
  if (!name) return 'bg-slate-700 text-white dark:bg-slate-900 dark:text-slate-400 border border-slate-700/50'

  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return avatarColors[Math.abs(hash) % avatarColors.length]
}
